import { WebLocale } from '@/enums/web-locale';

export type DisneyPromoCountries = (typeof CountriesAvailable)[number];
export const CountriesAvailable = ['DK', 'NO', 'SE'] as const;

type DisneyPromoTexts = Record<DisneyPromoCountries, PromoTexts>;
const PromotionTexts: DisneyPromoTexts = {
	DK: {
		ribbon: 'SALE',
		offerText: '19 kr./md.',
		longText: 'Særtilbud: 19 kr./måned',
		endDate: '2024-03-14',
	},
	NO: {
		ribbon: 'SALG',
		offerText: '19 kr./md.',
		longText: 'Supertilbud: 19 kr./måned',
		endDate: '2024-03-14',
	},
	SE: {
		ribbon: 'DEAL',
		offerText: '19 kr/mån',
		longText: '19 kr per mån i 3 månader',
		endDate: '2024-03-14',
	},
};

export const DisneyPlusId = 337 as const;

// Types just for fun
type digits = '0' | '1' | '2' | '3' | '4' | '5' | '6' | '7' | '8' | '9';
type day = `${'0'}${Exclude<digits, '0'>}` | `${'1' | '2'}${digits}` | '30' | '31';
type month = `${'0'}${Exclude<digits, '0'>}` | '10' | '11' | '12';
type year = `20${digits}${digits}`;
type ISO8601 = `${year}-${month}-${day}`;

interface PromoTexts {
	/** Set `null` to disable. */
	ribbon: string | null;
	/** Set `null` to disable. */
	offerText: string | null;
	/** Set `null` to disable. */
	longText: string | null;
	/** `YYYY-MM-DD` format. */
	endDate: ISO8601;
}

export const getDisneyPromoText: (country: string, currentDate?: Date) => PromoTexts | null = (
	country,
	currentDate = new Date()
) => {
	if (!CountriesAvailable.includes(country as any)) return null;

	const promoText = PromotionTexts[country as DisneyPromoCountries];
	if (promoText.endDate && +currentDate > new Date(promoText.endDate).setUTCHours(23, 59, 59, 999)) return null;

	return promoText;
};

// Disney External Pixel Tracking
const oceaniaLocales = new Set([WebLocale.au, WebLocale.nz]);
const latamLocales = new Set([
	WebLocale.br,
	WebLocale.mx,
	WebLocale.ar,
	WebLocale.cl,
	WebLocale.co,
	WebLocale.pe,
	WebLocale.uy,
	WebLocale.ec,
	WebLocale.pa,
	WebLocale.cr,
	WebLocale.py,
	WebLocale.bo,
	WebLocale.gt,
	WebLocale.ni,
	WebLocale.do,
	WebLocale.sv,
	WebLocale.hn,
	WebLocale.ve,
]);

export function getDisneyImpressionUrl(packageId: number | null | undefined, webLocale: WebLocale) {
	if (packageId === 337 /* Disney+ */) {
		if (oceaniaLocales.has(webLocale)) return 'https://imp.pxf.io/i/1206980/1833790/9358';

		if (latamLocales.has(webLocale)) return 'https://imp.pxf.io/i/1206980/1848147/9358';
	}

	if (packageId === 619 /* Star+ */) {
		if (latamLocales.has(webLocale)) return 'https://imp.pxf.io/i/1206980/1584316/13591';
	}

	return null;
}
